import React from "react";
import { Login } from "../../components/index";

export default function LoginPage() {
  return (
    <>
      <Login />
    </>
  );
}
